<template>
  <div
    class="card-count pa-2 white rounded-lg"
    :class="{
      'card-fluid': fluid,
      'card-active': cardActive,
      'cursor-pointer': canClick,
      hoverable: canClick,
      'shadow-lg': shadowLg,
    }"
    @click="$emit('click')"
  >
    <div>
      <v-icon class="pa-2 rounded-circle mx-2 icon" small> {{ icon }} </v-icon>
    </div>
    <div class="body">
      <div class="text--secondary">{{ title }}</div>
      <div class="font-weight-bold">{{ value }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fluid: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "mdi-ticket-outline",
    },
    cardActive: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "-",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    canClick: {
      type: Boolean,
      default: false,
    },
    shadowLg: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/color.scss";
.card-count {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 80px;
  height: 80px;
  .icon {
    color: $main_1;
    background-color: $main_1_opacity_10;
  }
  &.card-fluid {
    width: 100%;
    height: auto;
  }
  .body {
    font-size: 14px;
  }
  &.card-active {
    box-shadow: 0 1px 8px $main_1;
  }
  &.cursor-pointer {
    cursor: pointer;
  }
  &.hoverable:hover {
    box-shadow: 0 1px 8px $main_1;
    transition: box-shadow 0.3s ease-in-out;
  }
  &.shadow-lg {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  }
}
</style>
